import React, { useState } from 'react';
import { useMutation } from '@apollo/client';
import { Link } from 'react-router-dom';

import { ADD_USER } from '../utils/mutations';
import Auth from '../utils/auth';

function Signup() {
  const [formState, setFormState] = useState({ username: '', email: '', password: '' });
  const [validated] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [addUser, { error }] = useMutation(ADD_USER);

  const handleFormSubmit = async (event) => {
    event.preventDefault();

    try {
      const { data } = await addUser({
        variables: { ...formState },
      });

      Auth.login(data.addUser.token);
    } catch (err) {
      console.error(err);
      setShowAlert(true);
    }
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormState({ ...formState, [name]: value });
  };

  return (
    <div className="bg-slate-300">
    <div className="w-full max-w-md mx-auto p-4">
      <h2 className="text-2xl font-semibold mb-4">Signup</h2>
      <form noValidate validated={validated} onSubmit={handleFormSubmit}>
        <div className="mb-4">
          <label htmlFor="username" className="block text-slate-500 font-bold mb-2">
            Username:
          </label>
          <input
            type="text"
            name="username"
            id="username"
            onChange={handleChange}
            required
            className="text-black w-full px-3 py-2 border rounded-md shadow-sm focus:outline-none focus:border-blue-500"
          />
        </div>
        <div className="mb-4">
          <label htmlFor="email" className="block text-slate-500 font-bold mb-2">
            Email:
          </label>
          <input
            type="email"
            name="email"
            id="email"
            onChange={handleChange}
            required
            className="text-black w-full px-3 py-2 border rounded-md shadow-sm focus:outline-none focus:border-blue-500"
          />
        </div>
        <div className="mb-4">
          <label htmlFor="password" className="block text-slate-500 font-bold mb-2">
            Password:
          </label>
          <input
            type="password"
            name="password"
            id="password"
            onChange={handleChange}
            required
            className="text-black w-full px-3 py-2 border rounded-md shadow-sm focus:outline-none focus:border-blue-500"
          />
        </div>
        <button
          type="submit"
          className="w-full py-2 px-4 bg-slate-400 hover:bg-violet-700 text-white rounded-md focus:outline-none focus:ring focus:ring-blue-200"
        >
          Signup
        </button>
      </form>
      {error && <p className="text-red-600 mt-2">{error.message}</p>}
      {showAlert && (
        <p className="text-red-600 mt-2">Something went wrong with your signup.</p>
      )}
      <p className="mt-4">
        Already have an account?{' '}
        <Link to="/login" className="text-violet-700 hover:underline">
          Login here
        </Link>
      </p>
    </div>
    </div>
  );
}

export default Signup;
